import { SxProps, Theme } from "@mui/material/";

export const patientCardContainer = (
  isSelected: boolean,
  noBorder: boolean
): SxProps<Theme> => ({
  display: "flex",
  width: "100%",
  padding: "16px",
  alignItems: "center",
  gap: "16px",
  borderRadius: "8px",
  border: noBorder
    ? "none"
    : isSelected
      ? "1px solid var(--accent-main-f-7931-e, #F7931E)"
      : "1px solid var(--text-disabled-e-5-e-5-e-5, #E5E5E5)",
  backgroundColor: "var(--white-100, #FFFFFF)",
  boxShadow: noBorder ? "none" : "0px 4px 4px 0px rgba(89, 89, 89, 0.05);",
  // Only apply hover on devices with precise pointing (mouse)
  "@media (hover: hover) and (pointer: fine)": {
    "&:hover": {
      bgcolor: "#FFF3E7",
    },
  },
});

export const avatarContainer = (
  height: number = 60,
  width: number = 60
): SxProps<Theme> => ({
  display: "flex",
  width: `${width}px`,
  height: `${height}px`,
  justifyContent: "center",
  alignItems: "center",
});

export const textContainer: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  flex: "1 0 0px",
};

export const statusContainer: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
  gap: "8px",
};

export const dotBox: SxProps<Theme> = {
  width: "10px",
  marginTop: "-4px",
};

export const patientInfoContainers: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
};

export const patientInfoContainersContainer: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  flex: "1 0 0px",
  alignItems: "flex-start",
};

export const npContainer: SxProps<Theme> = {
  display: "flex",
  width: "28px",
  flexDirection: "column",
  padding: "2px 4px",
  alignItems: "flex-end",
  gap: "16px",
  alignSelf: "stretch",
  borderRadius: "4px",
};

export const npText: SxProps<Theme> = {
  display: "flex",
  padding: "2px 4px",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  borderRadius: "4px",
  backgroundColor: "var(--primary-main-f-7-b-500, #F7B500)",
  color: "var(--typography-graphics-black-000000, #000);",
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "normal",
  fontStyle: "normal",
  textAlign: "center",
  width: "30px",
};

export const topPatientInfoContainerText: SxProps<Theme> = {
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "normal",
  color: "var(--typography-graphics-black-000000, #000);",
  width: "253px",
};

export const bottomPatientInfoContainerText: SxProps<Theme> = {
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  color: "var(--typography-graphics-black-000000, #000);",
};

export const bottomPatientInfoContainerTextLight: SxProps<Theme> = {
  ...bottomPatientInfoContainerText,
  color: "var(--typography-graphics-dark-gray-595959, #595959);",
};

export const patientCardInfoContainersParentContainer: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
};
